<template>
  <div :id="'chart_'+uuid">
    <div class="chart-container" style="position: relative;" :style="`width: ${size.width}; height: ${size.height};`">
      <canvas :id="uuid" :width="size.width" :height="size.height" />
    </div>
  </div>
</template>

<script>
import { Chart } from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";
import {Colorize} from "@/libs/colorizer";

export default {
  name: "0e51d701-b6c3-11ee-8770-c85acf022408",
  props: ['chart', 'size', 'title', 'uuid'],
  mounted() {
    this.canvas = document.getElementById(this.uuid).getContext('2d')
    this.make_chart()
  },
  data() {
    return {
      canvas: null,
      graph: null,
      sides: [],
      periods: [],
      count: []
    }
  },
  computed: {
    report_data() {
      return this.chart.report_data
    }
  },
  watch: {
    report_data() {
      this.update_chart()
    }
  },
  methods: {
    make_chart: function () {
      this.update_data()
      if (this.canvas) {
        this.graph = new Chart(this.canvas, {
          type: 'bar',
          plugins: [ChartDataLabels],
          data: {
            labels: this.periods,
            datasets: [{
              label: 'Исполнитель',
              data: this.sides[1],
              maxBarThickness: 800
            },{
              label: 'Заказчик',
              data: this.sides[0],
              maxBarThickness: 800
            }]
          },
          options: {
            layout: {
              padding: {
                top: 25
              }
            },
            scales: {
              x: {
                stacked: true,
              },
              y: {
                stacked: true,
                ticks: {
                  beginAtZero: true,
                  callback: function (value) { if (Number.isInteger(value)) { return value } },
                  stepSize: 1
                },
                title: {
                  display: true,
                  text: 'Кол-во обращений'
                },
              }
            },
            plugins: {
              datalabels: {
                color: function (value) {
                  return Colorize(value.dataset.backgroundColor)
                },
                anchor: 'center',
                clamp: true,
                formatter: function (value) {
                  if (value > 0) return Math.ceil(value)
                  return null
                }
              },
              legend: {
                display: true
              },
            }
          }
        });
      }
    },
    update_data: function () {
      this.sides = []
      this.name = []
      this.count = []

      let sides_tmp = []
      this.report_data.map(el => {
        if (!sides_tmp.includes(el['Сторона'])) {
          sides_tmp.push(el['Сторона'])
        }
      })

      for (let side of sides_tmp) {
        this.sides.push({
          name: side,
          data: {
            less7days: 0,
            more7daysless30: 0,
            more30daysless90: 0,
            more90days: 0,
            final: 0
          }
        })
      }

      this.periods = [
          'Не закрыто менее 7 дней',
          'Не закрыто от 7 до 30 дней',
          'Не закрыто от 30 до 90 дней',
          'Не закрыто более 90 дней',
          'Итого'
      ]


      this.report_data.map(el => {
        let side = this.sides.find(element => element.name === el['Сторона'])
        if (side) {
          side.data.less7days += el['НезакрытоМенее7Дней']
          side.data.more7daysless30 += el['НезакрытоБолее7Менее30Дней']
          side.data.more30daysless90 += el['НезакрытоБолее30Менее90Дней']
          side.data.more90days += el['НезакрытоБолее90']
          side.data.final += el['КоличествоОбращений']
        }
      })


      this.sides = this.sides.map(e => {
        let keys = Object.keys(e.data)
        return keys.map(key => {
          return e.data[key]
        })
      })

    },
    update_chart: function () {
      this.update_data()
      this.graph.destroy()
      this.canvas = document.getElementById(this.uuid).getContext('2d')
      this.make_chart()
    }
  },
}
</script>
